import { render, staticRenderFns } from "./advertiser.vue?vue&type=template&id=5c39a551&"
import script from "./advertiser.vue?vue&type=script&lang=js&"
export * from "./advertiser.vue?vue&type=script&lang=js&"
import style0 from "./advertiser.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports